import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { ApprovalStatus } from '@biyolink/shared';
import { useAuthStore } from '@/stores/auth-store';
import { PageSpinner } from '@/components/ui';

/** Giriş yapılmamışsa /giris'e yönlendirir; dönüş adresi state'te taşınır. */
export function RequireAuth() {
  const user = useAuthStore((state) => state.user);
  const isLoading = useAuthStore((state) => state.isLoading);
  const location = useLocation();

  if (isLoading) return <PageSpinner />;
  if (!user) {
    return <Navigate to="/giris" replace state={{ from: location.pathname + location.search }} />;
  }

  return <Outlet />;
}

/**
 * Onaylı firma gerektiren sayfalar için. Onaysızsa panele geri gönderir —
 * kullanıcı orada onay durumu bandını görür (docs/05 §4.1).
 */
export function RequireApprovedCompany() {
  const company = useAuthStore((state) => state.company);
  const isLoading = useAuthStore((state) => state.isLoading);

  if (isLoading) return <PageSpinner />;
  if (company?.approvalStatus !== ApprovalStatus.APPROVED) {
    return <Navigate to="/panel" replace />;
  }

  return <Outlet />;
}

/** Yalnızca admin. */
export function RequireAdmin() {
  const user = useAuthStore((state) => state.user);
  const isLoading = useAuthStore((state) => state.isLoading);

  if (isLoading) return <PageSpinner />;
  if (user?.role !== 'ADMIN') return <Navigate to="/panel" replace />;

  return <Outlet />;
}

/** Giriş yapmış kullanıcıyı auth sayfalarından uzak tutar; admin yönetime gider. */
export function RedirectIfAuthenticated() {
  const user = useAuthStore((state) => state.user);
  const isLoading = useAuthStore((state) => state.isLoading);

  if (isLoading) return <PageSpinner />;
  if (user) return <Navigate to={user.role === 'ADMIN' ? '/admin' : '/panel'} replace />;

  return <Outlet />;
}
